var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_405_134)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 18H37.5C40.5376 18 43 20.4624 43 23.5V23.5C43 26.5376 40.5376 29 37.5 29H35",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2069 42V42C17.7789 42 15 39.2211 15 35.7931V35.5C15 31.9101 17.9101 29 21.5 29L27.5 29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 42,
    r: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 42,
    r: 1,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39L44 34",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42H29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 34.134C48.1667 34.5189 48.1667 35.4811 47.5 35.866L44.5 37.5981C43.8333 37.983 43 37.5019 43 36.7321L43 33.2679C43 32.4981 43.8333 32.017 44.5 32.4019L47.5 34.134Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_134",
    x1: 2.79397e-7,
    y1: 30,
    x2: 60,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A39ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484DBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.07ac8df2d6f34d2b69a0eb3d680b857a.svg";
export { ForwardRef as ReactComponent };